import { Conversion } from '../Conversion';
import { LeadCapture } from '../LeadCapture';

export const leadCaptureAndConversionTabs = [
  { index: 0, title: 'Captação', component: LeadCapture },
  { index: 1, title: 'Conversão de clientes', component: Conversion },
];
